/* eslint-disable react/jsx-no-bind */
import * as globalSettings from "../../lib/api/globalSettings";
import AlertModal from "../AlertModal";
import logger from "../../lib/logger";
import React, { PureComponent } from "react";
import { Button, Col, ControlLabel, FormControl, FormGroup, Grid, Row } from "react-bootstrap";
import { css, StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    verticalSpacing: {
        marginBottom: 25,
    },
    updateSettingsInput: {
        width: "25%",
    },
});

const strings = {
    documentTitle: "Global Settings | Habit CMS",
    pageTitle: "Global Settings",
    filterByName: "Filter by Campaign Name:",
    campaignName: "Campaign Name",
    CampaignsUrl: "global-settings",
    newSlug: "new",
    enterRedeemableId: "Default Offer - Punchh Redeemable ID",
    failedToUpdateGlobalSettings:
        "There was an error while updating the Global Settings. No changes were made.",
    redeemableId: "Redeemable Id",
    updateGlobalSettings: "Update Global Settings",
    updateSuccessful: "The Global Settings have been successfully updated."
};

class GlobalSettingsPage extends PureComponent {
    state = {
        redeemableId: "",
        currentRedeemableId: "",
        isLoading: false,
        showAlertModal: false,
        alertMsg: ""
    };

    componentDidMount() {
        document.title = strings.documentTitle;
        this._loadGlobalSettings();
    }

    _loadGlobalSettings= () => {
        this.setState({ isLoading: true });

        globalSettings
            .getCurrentGlobalSettings()
            .then(resp => {
                let redeemableId = "";
                if (resp.defaultRedeemableId !== null)
                {
                    redeemableId = resp.defaultRedeemableId.toString();
                }
                this.setState({
                    isLoading: false,
                    redeemableId : redeemableId,
                    currentRedeemableId : redeemableId,
                });
            }
            )
            .catch(e => {
                logger.warn(e);
                this.setState({ isLoading: false });
            });
    };

    _onRedeemableIdInputChange = e => {
        e.preventDefault();
        this.setState({ currentRedeemableId: e.target.value });
    };

    _handleUpdateGlobalSettings = () => {
        globalSettings
            .updateGlobalSettings({"defaultRedeemableId": this.state.currentRedeemableId})
            .then(() => {
                this.setState({ redeemableId: this.state.currentRedeemableId, showAlertModal: true, alertMsg: strings.updateSuccessful, isLoading: false });
            })
            .catch(e => {
                logger.warn(e);
                let alertMsg = strings.failedToUpdateGlobalSettings;
                if (
                    e &&
                    e.response &&
                    e.response.status === 400 &&
                    e.response.data &&
                    typeof e.response.data === "string"
                ) {
                    alertMsg = e.response.data;
                }
                this.setState({ isLoading: false, showAlertModal: true, alertMsg });
            });
    };

    _hideAlertModal = () => {
        this.setState({ showAlertModal: false });
        this._loadGlobalSettings();
    };

    _isValidSettingsUpdate = () => {
        return this.state.currentRedeemableId === "" || this.state.currentRedeemableId === this.state.redeemableId;
    }

    render() {
        return (
            <Grid>
                <Row>
                    <Col md={6}>
                        <h3 className={css(styles.verticalSpacing)} >
                            {strings.pageTitle}
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <ControlLabel>{strings.enterRedeemableId}</ControlLabel>
                            <FormControl
                                type="text"
                                className={css(styles.verticalSpacing, styles.updateSettingsInput)}
                                value={this.state.currentRedeemableId}
                                placeholder={strings.enterText}
                                onChange={this._onRedeemableIdInputChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col
                        md={12}
                    >
                        <Button
                            bsStyle="primary"
                            className={css(styles.updateSettingsInput)}
                            disabled={this.state.isLoading || this._isValidSettingsUpdate()}
                            onClick={this._handleUpdateGlobalSettings}
                        >
                            {strings.updateGlobalSettings}
                        </Button>
                    </Col>
                </Row>
                <AlertModal
                    show={this.state.showAlertModal}
                    alertMessage={this.state.alertMsg}
                    handleClose={this._hideAlertModal}
                />
            </Grid>

        );
    }
}

export default GlobalSettingsPage;
